export default __webpack_public_path__ + "static/media/i.0a910ec6.svg";